import request from '@/utils/request';
import {
  ICompanyUpdate,
  ICompanyDetail,
  ICompanySearch,
  ICompanyLog,
  ISearchKeyword,
} from '@/types/company';

const PATH = '/company';
const PATH2 = '/category';
const NTS_PATH = '/nts';

/* 회사 수정 (Update) - 변환 없이 바로 전송 */
export function updateCompany(data: ICompanyDetail, uid: string) {
  return request({
    url: `${PATH}/${uid}`, // uid를 URL에 사용
    method: 'put',
    data, // 그대로 전송
  });
}

/**
 * 작업명 : getCompanyInfo 구현
 * 기능: '나의' 회사 상세 정보 조회
 * 날짜: 2025-10-30
 */
export const getCompanyInfo = (uid: string) => request({
  url: `${PATH}/${uid}`,
  method: 'get',
});

/**
 * 작업명 : 공개용 회사 상세 정보 조회
 * 기능: uid를 기반으로 공개된 회사 상세 정보를 조회합니다.
 * 날짜: 2025-11-21
 */
export const getCompanyDetail = (uid: string) => request({
  url: `${PATH}/detail/${uid}`,
  method: 'get',
});

/**
 * 작업명 : 공개용 회사 상세 정보 조회
 * 기능: 유저 uid를 기반으로 공개된 회사 상세 정보를 조회합니다.
 * 날짜: 2026-01-06
 */
export const getCompanyName = (uid: string) => request({
  url: `${PATH}/name/${uid}`,
  method: 'get',
});

/* ===================== 카테고리 API ===================== */

/**
 * 기능: 존재하는 회사 카테고리 목록 조회
 * 날짜: 2025-11-14
 */
export const getMajorCategory = () => request({
  url: `${PATH2}/major`,
  method: 'get',
});

/* Sub 카테고리 조회 */
export const getSubCategory = () => request({
  url: `${PATH2}/sub`,
  method: 'get',
});

/**
 * 작업명: IR 기업 검색 API 함수 추가
 * 날짜: 2025-11-19
 * 기능: 검색 조건(ICompanySearch)을 받아 기업 목록을 조회합니다.
 */
export const searchCompany = (params: ICompanySearch) => request({
  url: `${PATH}/search`,
  method: 'get',
  params, // params 객체를 쿼리 스트링으로 자동 변환
});

/**
 * 작업명: IR 자료 검색 API 함수 추가
 * 날짜: 2025-11-28
 * 기능: IR 자료가 회사만
 */
export const searchCompanyIR = (params: ICompanySearch) => request({
  url: `${PATH}/searchIR`,
  method: 'get',
  params, // params 객체를 쿼리 스트링으로 자동 변환
});

/**
 * 작업명: 컨택 로그 추가 API 함수
 * 날짜: 2025-11-19
*/
export const addCompanyLog = (data: ICompanyLog) => request({
  url: '/company-log',
  method: 'post',
  data,
});

/**
 * 작업명: 회사 조회수 증가 API 함수
 * 날짜: 2025-11-21
*/
export const incrementCompanyView = (uid: any) => request({
  url: `${PATH}/${uid}/coViewCnt`,
  method: 'put',
});

/**
 * 작업명: 회사 조회수 증가 API 함수
 * 날짜: 2025-11-27
*/
export const incrementIRView = (uid: any) => request({
  url: `${PATH}/${uid}/irViewCnt`,
  method: 'put',
});

/**
 * 작업명: 유튜브 링크 API 함수 추가
 * 날짜: 2025-11-27
 */
export const searchYoutubeList = (params: ISearchKeyword) => request({
  url: `${PATH}/all-youtubelinks/search`,
  method: 'get',
  params, // params 객체를 쿼리 스트링으로 자동 변환
});

/**
 * 작업명: 국세청 사업자번호 검증 API 함수 추가
 * 날짜: 2025-12-01
 * 기능: 사업자번호를 검증하여 국세청 정보를 조회합니다.
 */
export const validateBusinessNumber = (businessNumber: string) => request({
  url: `${NTS_PATH}/status`,
  method: 'post',
  data: { businessNumber },
});
